import { z } from 'zod';
import { deepPartialOrNullable } from '../../../../helpers';
import { baseAiGeneratedResponseSchema } from './baseAiGeneratedResponseSchema';
import { AiCareDocumentWorkDetailsSchema } from './AiCareDocumentWorkDetailsSchema';
import { AiDateSchema } from './AiDateSchema';

export const InterimCareSummaryAiGeneratedSchema = z.object({
  patient: z
    .object({
      cancerType: z.string().nullish(),
      dob: AiDateSchema,
      work: deepPartialOrNullable(AiCareDocumentWorkDetailsSchema).nullish(),
    })
    .nullish(),

  expertSummary: z
    .object({
      motivation: z.string().nullish(),
    })
    .nullish(),
});

export type InterimCareSummaryAiGenerated = z.infer<
  typeof InterimCareSummaryAiGeneratedSchema
>;

export const InterimCareSummaryAiGeneratedResponseSchema =
  baseAiGeneratedResponseSchema(InterimCareSummaryAiGeneratedSchema);

export type InterimCareSummaryAiGeneratedResponse = z.infer<
  typeof InterimCareSummaryAiGeneratedResponseSchema
>;
